export const isValidPhoneNumber =
  (prefix: string, regex: RegExp) =>
  (text: string | undefined): boolean => {
    const nsn = text?.replace(prefix, '') || ''

    return regex.test(nsn.toString())
  }
